// TB-080: one place to turn a stored user / profile object into a name.
// Login stores firstName/lastName/name, get-profile may return fullName, an
// establishment only has name. Missing parts used to render as "Dr. undefined".

/** Trimmed text, or '' for null, undefined, 'undefined', 'null' and blanks. */
export function cleanPart (value) {
  if (value === null || value === undefined) return ''
  if (typeof value === 'object') return ''
  const s = String(value).trim()
  if (!s || s === 'undefined' || s === 'null') return ''
  return s
}

/** A person's name from any of the shapes the APIs return, or ''. */
export function personName (u) {
  if (!u || typeof u !== 'object') return ''
  const full = [cleanPart(u.firstName), cleanPart(u.lastName)].filter(Boolean).join(' ')
  return full || cleanPart(u.fullName) || cleanPart(u.name) || cleanPart(u.displayName)
}

/** First non empty name from a list of sources (objects or strings). */
export function pickName (...sources) {
  for (const s of sources) {
    const n = typeof s === 'object' ? personName(s) : cleanPart(s)
    if (n) return n
  }
  return ''
}

/** "Dr. Jane Doe" for a doctor, never "Dr. Dr. ...", '' when no name. */
export function doctorTitle (name) {
  const n = cleanPart(name).replace(/^dr\.?\s+/i, '')
  return n ? `Dr. ${n}` : ''
}

/**
 * Label for the signed-in account in the top bar.
 * role: 'provider' | 'establishment' | 'patient'
 */
export function accountLabel (role, ...sources) {
  if (role === 'establishment') {
    // Establishments have a name, not first/last; skip person-only fields.
    for (const s of sources) {
      const n = typeof s === 'object' ? (cleanPart(s && s.name) || cleanPart(s && s.establishmentName) || personName(s)) : cleanPart(s)
      if (n) return n
    }
    return 'Establishment'
  }
  const n = pickName(...sources)
  if (role === 'provider') return doctorTitle(n) || 'Doctor'
  return n
}
